var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ModBalanceWrap"},[_c('span',{staticClass:"valueTd__svg icon_dollars"},[_vm._v("$")]),_c('div',{class:['valueTd__text', _vm.getStatus()]},[_vm._v(_vm._s(_vm.getCurrency(_vm.line[_vm.item.value])))])])
}
var staticRenderFns = []

export { render, staticRenderFns }